"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./ConfirmationModal.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConfirmationModal = function ConfirmationModal(props) {
  var onConfirm = props.onConfirm,
      confirmCopy = props.confirmCopy,
      display = props.display,
      onClose = props.onClose;
  var bodyClasses = (0, _classnames.default)('confirm-modal-overlay', {
    displayed: display
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: bodyClasses
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "confirm-modal"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "confirm-modal-body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-text"
  }, confirmCopy), /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-choices"
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "cancel-button",
    onClick: onClose
  }, "Cancel"), /*#__PURE__*/_react.default.createElement("button", {
    className: "confirm-button",
    onClick: function onClick() {
      onConfirm();
      onClose();
    }
  }, "Yes")))));
};

ConfirmationModal.propTypes = {
  onConfirm: _propTypes.default.func.isRequired,
  onClose: _propTypes.default.func.isRequired,
  confirmCopy: _propTypes.default.string.isRequired
};
var _default = ConfirmationModal;
exports.default = _default;